import { createStore, combineReducers } from 'redux';
import campaignReducer from './Campaign/campaign.reducer';
import formsReducer from './Forms/forms.reducer';
import headerReducer from './Header/header.reducer';
import helpReducer from './Help/help.reducer';
import highlightFieldsReducer from './HighlightFields/highlightFields.reducer';
import overviewFiltersReducer from './OverviewFilters/overviewFilters.reducer';
import paramsConfigReducer from './ParamsConfig/paramsConfig.reducer';
import subCampaignReducer from './SubCampaign/subCampaign.reducer';
import userReducer from './User/user.reducer';
import workflowReducer from './Workflow/workflow.reducer';

const reducers = combineReducers({
  userReducer,
  campaignReducer,
  subCampaignReducer,
  overviewFiltersReducer,
  formsReducer,
  headerReducer,
  helpReducer,
  highlightFieldsReducer,
  workflowReducer,
  paramsConfigReducer,
});

const store = createStore(
  reducers,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(),
);

export default store;
